import { Button } from "@mui/material";

export const MyButton = (props) => {
  return (
    <Button
      sx={{ textTransform: props.textTransform ?? "uppercase" }}
      disabled={props.disabled != null ? props.disabled : false}
      className={props.className}
      style={{ marginTop: "1rem", ...props.style }}
      onClick={props.onClick}
      hidden={props.hidden ?? false}
      color={props.color ?? "primary"}
      // color={"primary"}
      variant={props.buttonVariant ?? "contained"}
      // variant={"contained"}
    >
      {props.text}
    </Button>
  );
};
